import React, { useState, useEffect } from "react";
import UserProfile, { logout } from "./components/UserProfile";
import LeftNavigation from "./components/LeftNavigation";
import Default from "./components/pages/Default";
import Admin from "./components/pages/Admin";
import Owner from "./components/pages/Owner";
import Profile from "./components/pages/Profile";
import Dashboard from "./components/pages/Dashboard";
import { DashboardProvider } from "./context/DashboardContext";
import "./styles/LeftNavigation.css";
import themeConfig from "./config/themeConfig";

const App = () => {
  const [currentPage, setCurrentPage] = useState("default");
  const [user, setUser] = useState(null);
  const [selectedNodeId, setSelectedNodeId] = useState(null);
  const [currentTheme, setCurrentTheme] = useState(() => {
    // Retrieve the saved theme from localStorage or default to 'default'
    return localStorage.getItem("currentTheme") || "default";
  });
  const [theme, setTheme] = useState(currentTheme);

  useEffect(() => {
    // Save the current theme to localStorage whenever it changes
    localStorage.setItem("currentTheme", currentTheme);
  }, [currentTheme]);

  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem("user"));
    if (storedUser) {
      setUser(storedUser);
    }

    const path = window.location.pathname;
    const nodeId = path.split("/").pop();
    if (nodeId.startsWith("d_")) {
      setCurrentPage("dashboard");
      setSelectedNodeId(nodeId);
    }
  }, []);

  useEffect(() => {
      // Apply the selected theme's CSS variables
      const theme = themeConfig.themes[currentTheme];
      setTheme(theme);
    }, [currentTheme]);

  if (!user) {
    return <UserProfile onLogin={setUser} />;
  }

  

  return (
    <DashboardProvider>
      <div className="layout-container">
        <LeftNavigation
          setCurrentPage={setCurrentPage}
          setSelectedNodeId={setSelectedNodeId}
          logout={logout}
          currentTheme={currentTheme} // Pass currentTheme
          setCurrentTheme={setCurrentTheme} // Pass setCurrentTheme
        />
        <div className="main-content">
          {currentPage === "default" && <Default theme={theme} />}
          {/* [New] Pass currentTheme to apply to header */}
          {currentPage === "admin" && <Admin theme={theme} />}
          {currentPage === "owner" && <Owner theme={theme} />}
          {currentPage === "profile" && (
            <Profile
              currentTheme={currentTheme}
              setCurrentTheme={setCurrentTheme}
            />
          )}
          {currentPage === "dashboard" && (
            <Dashboard
              nodeId={selectedNodeId}
              currentTheme={currentTheme}
              setSelectedNodeId={setSelectedNodeId}
            /> // Pass currentTheme
          )}
        </div>
      </div>
    </DashboardProvider>
  );
};

export default App;
